<template>
  <div class="mobile-offer-item">
    <div
      class="mobile-action"
      v-if="isShowRegularPayBtn || isShowEarlyPayBtn || isShowSignBtn || hasEarlyRepaymentActions || isLastPaymentInProgress || isLastPaymentFailed || isClaimSent || isLawsuitFiled"
    >
      <base-spinner
        v-if="isLastPaymentInProgress"
        :is-loading="true"
        :is-local="true"
        class="payment-progress-spinner"
        size="6px"
      />
      <template v-else>
        <base-button
          :text="$t(`message.profile.borrower.activeOffers.btn`)"
          class="action-btn"
          @click="openPayModal()"
          v-if="isShowRegularPayBtn"
          :disabled="!profile.default_card_id"
        />
        <base-button
          :text="$t('message.profile.borrower.earlyRepayment.payBtn')"
          class="early-pay-btn"
          @click="openEarlyRepaymentPay()"
          v-if="isShowEarlyPayBtn"
          :disabled="!profile.default_card_id"
        />
        <base-button
          :text="$t('message.profile.borrower.earlyRepayment.notifyBtn')"
          class="notify-btn"
          @click="openEarlyRepaymentNotify()"
          v-if="isShowNotifyMenu"
        />
        <div
          class="last-payment-failed-badge"
          v-if="isLastPaymentFailed"
          title="Последний платеж не выполнен"
        >
          Последний платеж не выполнен
        </div>
        <div
          class="er-awaiting-badge"
          v-if="isShowAwaitingIcon"
          :title="awaitingTooltip"
        >
          {{ awaitingTooltip }}
        </div>
        <base-button
          :text="$t('message.profile.borrower.activeOffers.signBtn')"
          class="sign-btn"
          @click="openContract()"
          v-if="isShowSignBtn"
        />
      </template>
      <div
        class="claim-sent-badge"
        v-if="isClaimSent"
        :title="claimSentTooltip"
        @click.stop
      >
        {{ claimSentTooltip }}
      </div>
      <div
        class="lawsuit-filed-badge"
        v-if="isLawsuitFiled"
        :title="lawsuitFiledTooltip"
        @click.stop
      >
        {{ lawsuitFiledTooltip }}
      </div>
    </div>
    <div class="preview-block" @click.stop="openTransactions(item.public_id)">
      <div class="mobile-row mobile-agreement" @click.stop="copyAgreementId">
        <div class="title">№ договора</div>
        <div class="data agreement-data">
          <span>{{ item?.Agreement?.document_id }}</span>
          <svg height="16" viewBox="0 0 16 16" width="16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path stroke="#A7A7A7" d="M10.6673 8.59998V11.4C10.6673 13.7333 9.73398 14.6666 7.40065 14.6666H4.60065C2.26732 14.6666 1.33398 13.7333 1.33398 11.4V8.59998C1.33398 6.26665 2.26732 5.33331 4.60065 5.33331H7.40065C9.73398 5.33331 10.6673 6.26665 10.6673 8.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
            <path stroke="#A7A7A7" d="M14.6673 4.59998V7.39998C14.6673 9.73331 13.734 10.6666 11.4007 10.6666H10.6673V8.59998C10.6673 6.26665 9.73398 5.33331 7.40065 5.33331H5.33398V4.59998C5.33398 2.26665 6.26732 1.33331 8.60065 1.33331H11.4007C13.734 1.33331 14.6673 2.26665 14.6673 4.59998Z" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
          </svg>
        </div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.name') }}</div>
        <div class="data">{{ userName }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</div>
        <div class="data">{{ offerIssuedDateTime }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</div>
        <div class="data">{{ (item.got_money / 100).toFixed(2) }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.term') }}</div>
        <div class="data">{{ mobileOfferTerm }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</div>
        <div class="data">{{ offerPercent }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.income') }}</div>
        <div class="data">{{ (item.initial_debt / 100).toFixed(2) }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</div>
        <div class="data">{{ offerIssueDate }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</div>
        <div class="data">{{ item.total_penalty / 100 }}</div>
      </div>
      <div class="mobile-row">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</div>
        <div class="data">{{ (item.rest_debt / 100).toFixed(2) }}</div>
      </div>
      <div class="mobile-row mobile-status">
        <div class="title">{{ $t('message.profile.borrower.activeOffers.items.status') }}</div>
        <div class="status-badge" :class="item.status">
          {{ $t(`message.profile.borrower.activeOffers.status.${item.status}`) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '../../components/base/BaseButton.vue';
import BaseSpinner from '../../components/base/BaseSpinner.vue';
import earlyRepaymentLoanItemMixin from '../../mixins/earlyRepaymentLoanItemMixin';

export default {
  name: 'MobileBorrowerLoanItem',
  mixins: [earlyRepaymentLoanItemMixin],
  props: {
    item: Object
  },
  components: {
    BaseButton,
    BaseSpinner
  },
  methods: {
    openTransactions(id) {
      this.$emit('openTransactions', id);
    },
    async copyAgreementId() {
      const agreementId = String(this.item?.Agreement?.document_id);

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(agreementId);
        } else {
          this.copyTextFallback(agreementId);
        }
      } catch (error) {
        this.copyTextFallback(agreementId);
      }

      this.$toast.success('Номер договора скопирован в буфер обмена');
    },
    copyTextFallback(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    },
    openPayModal() {
      this.$emit('openPayModal', {
        totalAmount: this.item.rest_debt,
        loan_public_id: this.item.public_id,
        initial_debt: this.item.initial_debt,
        total_penalty: this.item.total_penalty
      });
    },
    openContract() {
      this.$router.push({
        name: 'contract',
        query: { agreement_id: this.item?.Agreement?.document_id }
      });
    },
  },
  computed: {
    ...mapGetters(['profile']),
    userName() {
      const lastName = this.item?.Offer?.MsiIndividualUser?.name_ru?.family_name_ru;
      const name = (this.item?.Offer?.MsiIndividualUser?.name_ru?.given_name_ru).slice(0, 1) + '.';
      const middleNameRu = this.item?.Offer?.MsiIndividualUser?.name_ru?.middle_name_ru;
      const middleName = middleNameRu ? middleNameRu.slice(0, 1) + '.' : '';

      return `${lastName} ${name} ${middleName}`;
    },
    mobileOfferTerm() {
      return this.item?.Offer?.loan_term_days + ' д.';
    },
    offerPercent() {
      return this.item?.Offer?.annual_percent;
    },
    isShowSignBtn() {
      return this.item.status === 'signing';
    },
    offerIssuedDateTime() {
      return new Date(this.item?.createdAt).toLocaleString('ru-RU');
    },
    offerIssueDate() {
      return new Date(this.item?.due_date).toLocaleDateString();
    },
    isLoanOverdue() {
      return this.item?.status === 'overdue';
    },
    isClaimSent() {
      return this.isLoanOverdue && this.item?.claim?.exists === true && this.item?.claim?.status === 'sent';
    },
    isLawsuitFiled() {
      return this.isLoanOverdue && this.item?.lawsuit?.filed === true;
    },
    claimSentTooltip() {
      const createdAt = this.item?.claim?.created_at;
      const date = createdAt ? new Date(createdAt) : null;

      if (!date || Number.isNaN(date.getTime())) {
        return 'Претензия отправлена';
      }

      return `Претензия отправлена ${date.toLocaleDateString('ru-RU')}`;
    },
    lawsuitFiledTooltip() {
      const filedAt = this.item?.lawsuit?.created_at;
      const date = filedAt ? new Date(filedAt) : null;

      if (!date || Number.isNaN(date.getTime())) {
        return 'Иск подан';
      }

      return `Иск подан ${date.toLocaleDateString('ru-RU')}`;
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-offer-item {
  width: 100%;
  padding: 24px 16px 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 16px;
  line-height: 135%;
  font-weight: 400;
  color: #121212;
  background: #f8f8f8;
  border: 1px solid #cdcdcd;
  margin-bottom: 20px;
  border-radius: 4.8px;
}

.mobile-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.er-awaiting-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #cb7723;
  background: #fff1d5;
  border-radius: 6px;
  cursor: help;
}

.payment-progress-spinner {
  width: 22px;
  height: 22px;
}

.last-payment-failed-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #c93434;
  background: #ffdbdb;
  border-radius: 6px;
  cursor: help;
}

.claim-sent-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #cb7723;
  background: #fff1d5;
  border-radius: 6px;
  cursor: help;
}

.lawsuit-filed-badge {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  color: #c93434;
  background: #ffdbdb;
  border-radius: 6px;
  cursor: help;
}

.notify-btn ::v-deep {
  background-color: white;
  border: 2px solid #cb7723;
  border-radius: 6px;
  color: #cb7723;
  padding: 0 12px;
  font-size: 12px;
  line-height: 22px;
  font-weight: 600;
  height: 32px;
  white-space: nowrap;
}

.early-pay-btn ::v-deep {
  background-color: #41bf7b;
  border: 2px solid #41bf7b;
  border-radius: 6px;
  color: #ffffff;
  padding: 0 12px;
  font-size: 12px;
  line-height: 22px;
  font-weight: 600;
  height: 32px;
  white-space: nowrap;
}

.preview-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  box-sizing: border-box;
  cursor: pointer;
}

.mobile-row {
  min-height: 22px;
  margin-bottom: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.mobile-row:last-child {
  margin-bottom: 0;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 115%;
  color: #878787;
}

.data {
  max-width: 58%;
  font-size: 16px;
  line-height: 115%;
  text-align: right;
  word-break: break-word;
}

.agreement-data {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1a8d48;
  font-weight: 600;
  cursor: pointer;
}

.mobile-agreement:hover path {
  stroke: #1a8d48;
}

.agreement-data svg {
  flex-shrink: 0;
}

.mobile-status .status-badge {
  padding: 5px 11px;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 115%;
  border-radius: 6px;
}

.mobile-status .status-badge.payment,
.mobile-status .status-badge.on_due,
.mobile-status .status-badge.current_debt,
.mobile-status .status-badge.payment_pending {
  color: #cb7723;
  background: #fff1d5;
}

.mobile-status .status-badge.closed,
.mobile-status .status-badge.paid,
.mobile-status .status-badge.repaid {
  color: #21a15c;
  background: #d6f9d3;
}

.mobile-status .status-badge.expired,
.mobile-status .status-badge.overdue,
.mobile-status .status-badge.payment_failed {
  color: #c93434;
  background: #ffdbdb;
}

.mobile-status .status-badge.signing {
  color: #214ea1;
  background: #d3e5f9;
}

.mobile-status .status-badge.canceled {
  color: #6b6b6b;
  background: #eceef0;
}

.sign-btn ::v-deep {
  border-radius: 6px;
}

.action-btn ::v-deep {
  background-color: white;
  border: 2px solid #41bf7b;
  border-radius: 6px;
  color: #41bf7b;
  padding: 0 12px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  height: 32px;
  white-space: nowrap;

  &:hover {
    background-color: #41bf7b;
    color: white;
  }

  &.disabled {
    background-color: rgba(255, 255, 255, 0.5);
    border: 2px solid rgba(64, 191, 123, 0.5);
    color: rgba(64, 191, 123, 0.5);
  }

  &.disabled:hover {
    background-color: rgba(255, 255, 255, 0.5);
    border: 2px solid rgba(64, 191, 123, 0.5);
    color: rgba(64, 191, 123, 0.5);
  }
}
</style>
